import BaseListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

const ListItemSecondaryAction = BaseListItemSecondaryAction

export default ListItemSecondaryAction
